export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/email.2ce89534-3048b5.png";